import ReactMarkdown from 'react-markdown';
import termsMd from '@/content/terms.md?raw';

export function TermsPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6 lg:px-8">
      <article className="prose prose-sm max-w-none text-foreground">
        <ReactMarkdown>{termsMd}</ReactMarkdown>
      </article>
    </div>
  );
}
